import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
	providedIn: 'root',
})
export class AppLanguageService {
	langLocalStorageKey = 'langOfApp';
	currLang;

	private translate = inject(TranslateService);
	constructor() {
		this.initCorrectAppLang();
	}

	initCorrectAppLang() {
		const languageValue = localStorage.getItem(this.langLocalStorageKey) || 'de';
		this.currLang = languageValue;

		this.translate.setFallbackLang(languageValue);
		this.translate.use(languageValue);
		this.changeLang(languageValue);

		this.translate.onLangChange.pipe(takeUntilDestroyed()).subscribe(languageChanged => {
			if (languageChanged) localStorage.setItem(this.langLocalStorageKey, languageChanged.lang);
		});
	}

	changeLang(lang: string) {
		if (lang === 'ar') {
			this.translate.use('ar');
			document.body.style.direction = 'rtl';
			document.documentElement.dir = 'rtl';
			this.currLang = 'ar';
		} else {
			this.translate.use(lang);
			document.body.style.direction = 'ltr';
			document.documentElement.dir = 'ltr';
			this.currLang = lang;
		}

		setTimeout(() => requestAnimationFrame(() => this.changeSwiperDirection()));
	}

	changeSwiperDirection() {
		const swipers = document.querySelectorAll('swiper-container');
		if (!swipers.length) return;

		swipers.forEach(swiper => {
			swiper.swiper.changeLanguageDirection(this.currLang === 'ar' ? 'rtl' : 'ltr');
			swiper.swiper.updateSize();
		});
	}
}
